import script from "./FiltersResults.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersResults.vue?vue&type=script&setup=true&lang=js"

import "./FiltersResults.vue?vue&type=style&index=0&id=2951a691&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2951a691"]])

export default __exports__